import React, { useEffect, useState } from "react";
import { FaCalendar, FaUsers, FaTrophy, FaSeedling, FaIndustry, FaRocket, FaCog, FaWrench, FaCar, FaTools } from "react-icons/fa";
import CountUp from "react-countup";

const About = () => {
  const [visibleElements, setVisibleElements] = useState(new Set());

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setVisibleElements(prev => new Set([...prev, entry.target.dataset.animate]));
          }
        });
      },
      { threshold: 0.1, rootMargin: "0px 0px -50px 0px" }
    );

    document.querySelectorAll('[data-animate]').forEach((el) => {
      observer.observe(el);
    });

    return () => observer.disconnect();
  }, []);

  const timelineData = [
    {
      year: "2017",
      title: "The Foundation",
      icon: <FaSeedling />,
      description: "Keerthisagar A M founded Simple Mechanical Solutions in Sagar, Karnataka. What started as a mechanical engineering consultancy soon expanded into agricultural machinery fabrication and mechanical innovations.",
      features: [
        "Mechanical project designs & consultancy",
        "Agricultural machinery fabrication", 
        "Pre-owned vehicle consultancy services",
        "YouTube channel educating thousands"
      ]
    },
    {
      year: "2022", 
      title: "Industrial Excellence",
      icon: <FaIndustry />,
      description: "Co-founded CUTTECH SOLUTIONS, a precision tooling company serving major industries. This venture established direct relationships with manufacturers, ensuring access to genuine spare parts.",
      features: [
        "Automotive & Aerospace industries",
        "Defense & Locomotive sectors", 
        "Wind Energy & General Engineering",
        "Direct manufacturer relationships"
      ]
    },
    {
      year: "2025",
      title: "The Revolution", 
      icon: <FaRocket />,
      description: "ASK MECHANICS was born from years of experience and a clear vision: to eliminate the uncertainty and stress of vehicle breakdowns through technology-driven, transparent, and reliable automotive care.",
      features: [
        "Pan-India on-demand mechanic network",
        "24/7 roadside assistance & emergency repairs",
        "Genuine spare parts through direct sourcing", 
        "Complete transparency with digital job cards",
        "Technology-enabled service platform"
      ]
    }
  ];

  return (
    <div className="main-container">
      <style jsx>{`
        .main-container {
          background-color: #f5f5f5;
          font-family: Arial, sans-serif;
        }

        .about-container {
          padding: 20px;
          margin-top: 60px;
        }

        .about-section {
          background-color: #ffffff;
          border-radius: 8px;
          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
          justify-content: center;
          align-items: center;
          padding: 20px;
          width: 90%;
          max-width: 580px;
          box-sizing: border-box;
          transition: transform 0.2s ease-in-out;
          margin: 10px 30px 10px 30px;
        }

        .about-section:hover {
          transform: scale(1.02);
        }

        .about-headers {
          color: rgb(8, 8, 8);
          margin-bottom: 10px;
          border-bottom: 2px solid #f9d342;
          padding-bottom: 5px;
        }

        .about-container-details p {
          color: #5f5e5e;
          font-size: 1rem;
          line-height: 1.5;
        }

        .circle-letter {
          display: inline-block;
          width: 40px;
          height: 40px;
          line-height: 40px;
          border-radius: 50%;
          background-color: #f9d342;
          color: black;
          font-size: 32px;
          font-weight: bold;
          text-align: center;
          margin-right: 8px;
          font-family: Arial, sans-serif;
        }

        .experience-section {
          display: flex;
          justify-content: space-around;
          align-items: center;
          flex-wrap: wrap;
          background-color: #333;
          color: #fff;
          padding: 1rem 1rem;
          text-align: center;
        }

        .experience-item {
          text-align: center;
          margin: 1rem;
          max-width: 300px;
        }

        .experience-icon {
          font-size: 3rem;
          color: #f9d342;
        }

        .experience-item h3 {
          margin-top: 0.5rem;
        }

        /* Enhanced Our Story Section */
        .our-story {
          padding: 4rem 2rem;
          background: #ffffff;
          position: relative;
          overflow: hidden;
          min-height: 80vh;
        }

        .our-story::before {
          content: "";
          position: absolute;
          top: 0;
          left: -100px;
          right: 0;
          bottom: 0;
          background-image: 
            radial-gradient(circle at 25px 25px, rgba(249, 211, 66, 0.05) 2px, transparent 2px);
          background-size: 50px 50px;
          z-index: 1;
        }

        .story-header {
          text-align: center;
          margin-bottom: 4rem;
          position: relative;
          z-index: 2;
        }

        .story-title {
          font-weight: 800;
          font-size: 2.8rem;
          color: #333;
          margin-bottom: 1rem;
          position: relative;
          text-transform: uppercase;
          letter-spacing: 2px;
        }

        .story-title::after {
          content: "";
          position: absolute;
          bottom: -10px;
          left: 50%;
          transform: translateX(-50%);
          width: 100px;
          height: 4px;
          background: linear-gradient(135deg, #f9d342, #ffc107);
          border-radius: 2px;
        }

        .story-subtitle {
          font-size: 1.2rem;
          color: #666;
          max-width: 700px;
          margin: 0 auto;
          font-weight: 400;
          line-height: 1.6;
        }

        .floating-icons {
          position: absolute;
          width: 100%;
          height: 100%;
          top: 0;
          left: 0;
          pointer-events: none;
          z-index: 1;
        }

        .floating-icon {
          position: absolute;
          opacity: 0.03;
          color: #f9d342;
          animation: float 8s ease-in-out infinite;
        }

        .floating-icon:nth-child(1) {
          top: 15%;
          left: 8%;
          animation-delay: 0s;
        }
        .floating-icon:nth-child(2) {
          top: 25%;
          right: 12%;
          animation-delay: 3s;
        }
        .floating-icon:nth-child(3) {
          bottom: 35%;
          left: 15%;
          animation-delay: 6s;
        }
        .floating-icon:nth-child(4) {
          bottom: 25%;
          right: 8%;
          animation-delay: 1.5s;
        }

        @keyframes float {
          0%, 100% {
            transform: translateY(0px) rotate(0deg);
          }
          50% {
            transform: translateY(-25px) rotate(8deg);
          }
        }

        .timeline-container {
          position: relative;
          z-index: 2;
          max-width: 1100px;
          margin: 0 auto;
        }

        .timeline {
          position: relative;
          padding: 2rem 0;
        }

        .timeline::before {
          content: "";
          position: absolute;
          width: 4px;
          background: linear-gradient(180deg, #333, #555);
          top: 0;
          bottom: 0;
          left: 50%;
          margin-left: -2px;
          border-radius: 2px;
          box-shadow: 0 0 15px rgba(51, 51, 51, 0.2);
        }

        .timeline-item {
          position: relative;
          background-color: transparent;
          width: 40%;
          padding: 2.5rem;
          margin-bottom: 3rem;
          opacity: 0;
          transform: translateX(-50px);
          transition: all 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94);
        }

        .timeline-item.visible {
          opacity: 1;
          transform: translateX(0);
        }

        .timeline-item:nth-child(odd) {
          left: 0;
          text-align: right;
          padding-right: 4rem;
        }

        .timeline-item:nth-child(even) {
          left: 50%;
          text-align: left;
          padding-left: 4rem;
          transform: translateX(50px);
        }

        .timeline-item:nth-child(even).visible {
          transform: translateX(0);
        }

        .timeline-content {
          background: linear-gradient(135deg, #333, #444);
          padding: 2.5rem;
          border-radius: 20px;
          box-shadow: 0 15px 35px rgba(0, 0, 0, 0.15);
          border: 2px solid transparent;
          background-clip: padding-box;
          transition: all 0.4s ease;
          position: relative;
          color: #fff;
          overflow: hidden;
        }

        .timeline-content::before {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: linear-gradient(135deg, rgba(249, 211, 66, 0.05), rgba(255, 193, 7, 0.05));
          border-radius: 18px;
          z-index: 0;
        }

        .timeline-content > * {
          position: relative;
          z-index: 1;
        }

        .timeline-content:hover {
          transform: translateY(-8px);
          box-shadow: 0 25px 50px rgba(0, 0, 0, 0.25);
          border-color: #f9d342;
        }

        .timeline-year {
          background: linear-gradient(135deg, #f9d342, #ffc107);
          color: #000;
          padding: 0.7rem 1.5rem;
          border-radius: 30px;
          font-weight: 800;
          font-size: 1.1rem;
          display: inline-block;
          margin-bottom: 1.5rem;
          box-shadow: 0 8px 20px rgba(249, 211, 66, 0.3);
          letter-spacing: 1px;
        }

        .timeline-title {
          font-weight: 700;
          font-size: 1.6rem;
          color: #fff;
          margin-bottom: 1.2rem;
          letter-spacing: 0.5px;
        }

        .timeline-description {
          color: #e0e0e0;
          font-size: 1rem;
          line-height: 1.7;
          margin-bottom: 1.5rem;
        }

        .timeline-icon {
          position: absolute;
          width: 60px;
          height: 60px;
          background: linear-gradient(135deg, #f9d342, #ffc107);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 1.4rem;
          color: #000;
          box-shadow: 0 0 0 8px #fff, 0 0 20px rgba(249, 211, 66, 0.4);
          top: 2.5rem;
          z-index: 3;
        }

        .timeline-item:nth-child(odd) .timeline-icon {
          right: -30px;
        }

        .timeline-item:nth-child(even) .timeline-icon {
          left: -30px;
        }

        .timeline-features {
          list-style: none;
          padding: 0;
          margin: 0;
          display: grid;
          gap: 0.8rem;
        }

        .timeline-features li {
          padding: 0.6rem 0;
          color: #d0d0d0;
          position: relative;
          padding-left: 2rem;
          font-size: 0.95rem;
          line-height: 1.4;
          transition: color 0.3s ease;
        }

        .timeline-features li::before {
          content: "✓";
          position: absolute;
          left: 0;
          color: #f9d342;
          font-weight: bold;
          font-size: 1.1rem;
          top: 0.5rem;
        }

        .timeline-features li:hover {
          color: #f9d342;
        }

        .our-founders-wrapper {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          text-align: center;
          padding: 40px 10px;
          background-color: #f5f5f5;
        }

        .our-founders-wrapper h1 {
          font-size: 2.5em;
          font-weight: bold;
          color: #333;
          margin-bottom: 0px;
          text-transform: uppercase;
          letter-spacing: 1px;
        }

        .founders-section-container {
          display: flex;
          justify-content: center;
          gap: 30px;
          margin: 30px;
          text-align: center;
        }

        .founder {
          position: relative;
          width: 370px;
          height: 340px;
          margin: 20px;
          overflow: hidden;
        }

        .founder-section h5,
        .co-founder-section h5 {
          font-size: 1.5em;
          font-weight: bold;
          color: #333;
          text-transform: uppercase;
          margin: 10px 0;
          letter-spacing: 1px;
        }

        .founder-section p,
        .co-founder-section p {
          font-size: 1em;
          color: #0c0c0c;
          margin-top: 5px;
          font-style: italic;
          letter-spacing: 0.5px;
        }

        .founder img {
          width: 90%;
          height: 100%;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
        }

        .hover-text {
          position: absolute;
          bottom: -100%;
          left: -3%;
          right: -3%;
          height: 92%;
          padding: 15px;
          background-color: rgba(204, 85, 0, 0.8);
          color: white;
          border-radius: 12px;
          transition: bottom 0.3s ease-in-out, opacity 0.3s ease-in-out;
          opacity: 0;
          text-align: center;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
        }

        .founder:hover .hover-text {
          color: white;
          bottom: 0;
          opacity: 1;
        }

        .founder h3 {
          margin-top: 0;
          font-size: 1.3em;
          font-weight: bold;
        }

        .founder p {
          font-size: 1em;
          color: #f5f5f5;
          line-height: 1.4;
          margin-top: 10px;
        }

        @media (min-width: 768px) {
          .about-container {
            display: flex;
            justify-content: space-between;
          }
          .about-section {
            flex: 1;
          }
        }

        @media (max-width: 767px) {
          .about-container {
            display: block;
          }
          .about-section {
            margin: 10px auto;
          }
          .experience-section {
            padding: 1rem;
            flex-direction: column;
            align-items: center;
          }
          .experience-item {
            flex: 1 1 auto;
            max-width: 90%;
            margin: 1rem 0;
          }
          .experience-icon {
            font-size: 2rem;
          }
          .experience-item h3 {
            font-size: 16px;
            margin-top: 0.5rem;
          }
          .experience-item p {
            font-size: 14px;
          }

          /* Mobile Our Story Section */
          .our-story {
            padding: 2rem 1rem;
            min-height: auto;
          }
          
          .story-title {
            font-size: 2rem;
            letter-spacing: 1px;
          }
          
          .story-subtitle {
            font-size: 1rem;
            padding: 0 1rem;
          }
          
          .story-header {
            margin-bottom: 2.5rem;
          }
          
          .timeline::before {
            left: 25px;
            width: 3px;
          }
          
          .timeline-item {
            width: 100% !important;
            left: 0 !important;
            text-align: left !important;
            padding-left: 4rem !important;
            padding-right: 1rem !important;
            transform: translateX(0) !important;
            padding-top: 1.5rem;
            padding-bottom: 1.5rem;
            margin-bottom: 2rem;
          }
          
          .timeline-content {
            padding: 1.8rem;
            border-radius: 15px;
          }
          
          .timeline-item .timeline-icon {
            left: -5px !important;
            right: auto !important;
            width: 50px;
            height: 50px;
            font-size: 1.2rem;
            top: 1.8rem;
            box-shadow: 0 0 0 6px #fff, 0 0 15px rgba(249, 211, 66, 0.3);
          }
          
          .timeline-year {
            padding: 0.5rem 1.2rem;
            font-size: 1rem;
            margin-bottom: 1rem;
          }
          
          .timeline-title {
            font-size: 1.3rem;
            margin-bottom: 1rem;
          }
          
          .timeline-description {
            font-size: 0.9rem;
            margin-bottom: 1.2rem;
          }
          
          .timeline-features li {
            font-size: 0.85rem;
            padding: 0.4rem 0;
            padding-left: 1.5rem;
          }
          
          .floating-icon {
            opacity: 0.02;
          }

          .our-founders-wrapper h1 {
            font-size: 1.6em;
          }
          .founders-section-container {
            flex-direction: column;
            gap: 20px;
          }
          .founder {
            width: 300px;
            height: 270px;
            margin: 10px 0;
          }
          .founder img {
            width: 90%;
          }
          .hover-text {
            padding: 12px;
            height: 100%;
          }
          .founder h3 {
            font-size: 1.1em;
          }
          .founder p {
            font-size: 0.9em;
          }
          .founder-section h5,
          .co-founder-section h5 {
            font-size: 1.3em;
            letter-spacing: 0.5px;
          }
          .founder-section p,
          .co-founder-section p {
            font-size: 0.9em;
          }
        }

        /* Tablet specific styles */
        @media (min-width: 768px) and (max-width: 1024px) {
          .our-story {
            padding: 3rem 1.5rem;
          }
          
          .timeline-item {
            padding: 2rem;
          }
          
          .timeline-content {
            padding: 2rem;
          }
          
          .story-title {
            font-size: 2.4rem;
          }
          
          .story-subtitle {
            font-size: 1.1rem;
          }
        }
      `}</style>

      <div className="about-container">
        <div className="about-section quick-view">
          <h2 className="about-headers">Quick View</h2>
          <div className="about-container-details">
            <p>
              <span className="circle-letter">C</span>UTTECH Solutions leverage
              over 14 years of cutting-edge expertise combined with
              state-of-the-art manufacturing technologies to drive innovation.
              As a unified entity born from the merger of Simple Mechanical
              Solutions, we craft precision-engineered tools
              using advanced materials such as solid carbide, CBN, and PCD. Our
              tools meet the demands of high-performance machining, offering
              exceptional durability, precision, and reliability across a range
              of industrial applications.
            </p>
          </div>
        </div>
        <div className="about-section our-legacy">
          <h2 className="about-headers">Our Legacy</h2>
          <div className="about-container-details">
            <p>
              With over 14 years of industry experience, CUTTECH Solutions has
              consistently delivered reliable, high-quality cutting tools that
              meet stringent standards. This legacy, rooted in innovation and
              customer trust, has established the brand as a global benchmark in
              the cutting tools sector.
            </p>
          </div>
        </div>
      </div>

      <div className="experience-section">
        <div className="experience-item">
          <FaCalendar className="experience-icon" />
          <h3>
            <CountUp start={0} end={14} duration={5} />+
          </h3>
          <p>of Industry Experience</p>
        </div>

        <div className="experience-item">
          <FaUsers className="experience-icon" />
          <h3>
            <CountUp start={0} end={68} duration={5} />+
          </h3>
          <p>Happy Clients</p>
        </div>

        <div className="experience-item">
          <FaTrophy className="experience-icon" />
          <h3>Global Recognition</h3>
          <p>in Cutting Tools</p>
        </div>
      </div>

      {/* Enhanced Our Story Section */}
      <section className="our-story">
        <div className="floating-icons">
          <FaCog className="floating-icon" style={{ fontSize: '4rem' }} />
          <FaWrench className="floating-icon" style={{ fontSize: '3rem' }} />
          <FaCar className="floating-icon" style={{ fontSize: '3rem' }} />
          <FaTools className="floating-icon" style={{ fontSize: '4rem' }} />
        </div>

        <div className="story-header">
          <h2 className="story-title" data-animate="story-title">Our Story</h2>
          <p className="story-subtitle" data-animate="story-subtitle">
            From a vision to transform automotive care to becoming Indias most
            trusted on-demand mechanic service
          </p>
        </div>

        <div className="timeline-container">
          <div className="timeline">
            {timelineData.map((item, index) => (
              <div 
                key={index}
                className={`timeline-item ${visibleElements.has(`timeline-${index}`) ? 'visible' : ''}`}
                data-animate={`timeline-${index}`}
              >
                <div className="timeline-content">
                  <div className="timeline-year">{item.year}</div>
                  <h3 className="timeline-title">{item.title}</h3>
                  <p className="timeline-description">
                    {item.description}
                  </p>
                  <ul className="timeline-features">
                    {item.features.map((feature, idx) => (
                      <li key={idx}>{feature}</li>
                    ))}
                  </ul>
                </div>
                <div className="timeline-icon">
                  {item.icon}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <div className="our-founders-wrapper">
        <h1>OUR FOUNDERS</h1>
        <div className="founders-section-container">
          <div className="founder-section">
            <div className="founder">
              <img src="/Cuttech_Founder.png" alt="Keerthisagar A. M" />
              <div className="hover-text">
                <h3>Keerthisagar A. M</h3>
                <p>
                  The founder of Simple Mechanical Solutions, a certified Metal
                  Cutting Engineer from Sandvik Coromant, and an advocate for
                  high-precision and performance-driven solutions.
                </p>
              </div>
            </div>
            <h5>Keerthisagar A M</h5>
            <p>Founder</p>
          </div>
          <div className="co-founder-section">
            <div className="founder">
              <img src="Cuttech_CoFounder.jpeg" alt="Founder 2" />
              <div className="hover-text">
                <h3>Mr. Srinivas Govindaiah</h3>
                <p>
                  The co-founder, a distinguished expert with over three decades
                  of experience in tool design, manufacturing, and industrial
                  applications.
                </p>
              </div>
            </div>
            <h5>Mr. Srinivas Govindaiah</h5>
            <p>Co Founder</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;